<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_black.png" alt="logo图">
    </div>
    <p class="title">苏州启芯能能源科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：苏州市高新区嘉陵江路198号太湖光子科技园1号楼</span>
      <a href="tel:13584976662" class="tel-text">Tel：13584976662</a>
    </p>
    <p class="email_wx">
      <a href="javascript:void(0);" class="tel-text"
        @click="copyText('邮箱', '13584976662@163.com')">邮箱：13584976662@163.com</a>
      <a href="javascript:void(0);" class="tel-text" @click="copyText('微信号', '13584976662')">微信号：13584976662</a>
      <span></span>
    </p>
    <p class="copy">Copyright &copy; 2025 - {{ new Date().getFullYear() }} 苏州启芯能能源科技有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    copyText(title, text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          alert(title + '已复制到剪贴板！');
        }).catch(() => { });
      }
      return false
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #020305;
  overflow: hidden;
  text-align: center;
}

.logo {
  width: 95px;
  /* height: 45px; */
  margin: 50px auto 20px;
}

.logo img {
  width: 120px;
  /* height: 45px; */
  /* margin: 50px auto 20px; */
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}

.tel-text {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue